import { useMutation, useQuery } from "@tanstack/react-query";
import { WorkflowAPI } from "modules/Library/Workflow/api/workflow.api";
import { perPageData } from "common/service/CommonService";

// Workflow

export const useInsertWorkflowData = () => {
  const insertWorkflowData = useMutation({
    mutationFn: WorkflowAPI.insertData,
  });

  return { insertWorkflowData };
};

export const useSelectAllWorkflowData = (
  searchText?: string | null,
  currentPage?: number | null,
  pageSize?: number | null,
) => {
  const selectAllQuery = useQuery({
    queryKey: [
      "workflow-selectall",
      searchText,
      currentPage ?? 1,
      pageSize ?? perPageData,
    ],
    queryFn: () =>
      WorkflowAPI.getSelectAllData(searchText, currentPage, pageSize),
    // staleTime: 1000 * 60 * 2,
  });

  return { selectAllQuery };
};

export const useSelectWorkflowData = (id?: number | null) => {
  const selectQuery = useQuery({
    queryKey: ["workflow-select", id],
    queryFn: () => WorkflowAPI.getSelectData(id),
    enabled: !!id,
  });

  return { selectQuery };
};

export const useDeleteWorkflowData = () => {
  const deleteWorkflowData = useMutation({
    mutationFn: WorkflowAPI.deleteData,
  });

  return { deleteWorkflowData };
};

export const useUpdateWorkflowData = () => {
  const updateWorkflowData = useMutation({
    mutationFn: WorkflowAPI.updateData,
  });

  return { updateWorkflowData };
};

export const useStageSelectWorkflowData = (payload: any) => {
  const stageSelectQuery = useQuery({
    queryKey: ["workflow-stage-select", payload],
    queryFn: () => WorkflowAPI.getStageSelectData(payload),
    enabled: !!payload?.studyid && !!payload?.workflowid,
  });

  const switchStageMutation = useMutation({
    mutationFn: WorkflowAPI.switchStageData,
  });

  return { stageSelectQuery, switchStageMutation };
};

export const useQueryWorkflowData = (payload: any) => {
  const querySelectAll = useQuery({
    queryKey: ["workflow-query-selectall", payload],
    queryFn: () => WorkflowAPI.getQuerySelectAllData(payload),
    enabled: !!payload?.studyid,
  });

  const raiseQueryMutation = useMutation({
    mutationFn: WorkflowAPI.raiseQueryData,
  });

  const updateQueryMutation = useMutation({
    mutationFn: WorkflowAPI.updateQueryData,
  });

  return { querySelectAll, raiseQueryMutation, updateQueryMutation };
};
